import React from "react";

import modals from "./modal/index";

/*
  class Modal
  ModalMainがマウントされると、ModalMainを登録し、
  ModalMainへのアクセスをプロキシする。
  これにより、globalなコンテクストから、ModalMainへのアクセスを可能にする
  また、ModalMainのマウントを、ready()で待つことができる。
*/

class Modal {
  component;
  readyPromise;
  readyCallback;
  constructor() {
    this.readyPromise = new Promise((resolve, reject) => {
      this.readyCallback = () => {
        resolve();
      };
    });
  }
  registerCoponennt(component) {
    this.component = component;
    this.readyCallback();
  }
  // マウントされると解決されるPromiseを返す
  ready() {
    return this.readyPromise;
  }
  openModal(...args) {
    this.component.openModal(...args);
  }
  closeModal(...args) {
    this.component.closeModal(...args);
  }
  back(...args) {
    this.component.back(...args);
  }
}

export const modal = new Modal();
window.modal = modal;

export class ModalMain extends React.Component {
  state = {};
  history = [];
  constructor(props) {
    super(props);
    modal.registerCoponennt(this);
  }
  openModal(modalId, modalProps) {
    this.history.push({ modalId, modalProps })
    return new Promise((resolve, reject) => {
      this.setState({
        modalId,
        modalProps: Object.assign(
          {
            type: this.props.type,
            closeModal: response => {
              resolve(response);
              this.closeModal();
            },
          },
          modalProps
        ),
      });
    });
  }
  closeModal() {
    this.history = [];
    this.setState({
      modalId: null,
      modalProps: null,
    });
  }
  back() {
    this.history.pop();
    const params = this.history.pop();
    this.openModal(params.modalId, params.modalProps);
  }
  render() {
    if (this.state.modalId) {
      const modalFunc = modals[this.state.modalId];
      return (
        <div className="modal_over" show={this.state.modalId}>
          {modalFunc(this.state.modalProps)}
        </div>
      );
    } else {
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./common/modal.js